export abstract class ApiConfigService {
    abstract getServerRoot(route: string): string;
}
